<template>
  <div>
    <el-row :gutter="20">

      <el-col :md="8" :lg="5">
        <el-input placeholder="广告描述" v-model="params.ad_desc" clearable><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
      </el-col>
      <el-col :span="3" class="content-right">
        <el-button type="primary" icon="plus" @click="handleAdd">添加广告</el-button>
      </el-col>
    </el-row>
    <el-row>

    </el-row>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="广告列表" name="admin"></el-tab-pane>
      <el-table :data="list" :height="wheight-160" v-loading="loading">
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="is_publish" label="是否发布">
          <template slot-scope="scope">
            <el-tag
                    :type="scope.row.is_publish == 0 ? 'info' : 'success'"
                    disable-transitions>{{scope.row.is_publish == 0 ?'未发布' :'已发布'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="is_publish" label="是否全店铺">
          <template slot-scope="scope">
              <el-tag
                      :type="scope.row.all_type == 1 ? 'warning' : 'primary'"
                      disable-transitions>{{scope.row.all_type == 0 ?'部分店铺' :'全平台'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="show_type" label="显示范围">
          <template slot-scope="scope">
            <span v-if="scope.row.show_type == '0'">全部显示</span>
            <span v-if="scope.row.show_type == '1'">app显示</span>
            <span v-if="scope.row.show_type == '2'">小程序显示</span>
          </template>
        </el-table-column>
        <el-table-column prop="distributor_name" label="所属店铺">
          <template slot-scope="scope">
            <el-tag v-for="taglist in scope.row.distributorList" :key="taglist.index"  size="mini"  style="display: inline-block; margin-right:3px;">
              {{taglist.name}}
            </el-tag>

          </template>
        </el-table-column>

        <el-table-column prop="link,short_link,wx_app_link" label="链接">
          <template slot-scope="scope">
            链接：{{scope.row.link}} <br/>
            短连接：{{scope.row.short_link}} <br/>
            小程序连接：{{scope.row.wx_app_link}}
          </template>
        </el-table-column>
        <el-table-column prop="image" label="图片">
          <template slot-scope="scope">
            <el-popover
                    placement="right"
                    width="240"
                    trigger="hover" >
              <img  :src="wximageurl + scope.row.image" style="width:100%;">
              <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column prop="ad_desc" label="描述"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="cardname" label="优惠券"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="operating-icons">
              <i class="iconfont icon-edit1" @click="handleUpdate(scope.row)"></i>
              <el-button type="primary" size="mini" @click="handleEditDistribution(scope.row)">编辑店铺</el-button>
              <i class="mark iconfont icon-trash-alt1" @click="handleDelete(scope.$index, scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination background
                       layout="prev, pager, next, total"
                       @current-change="handleCurrentChange"
                       :current-page.sync="params.page"
                       :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>

    <el-dialog title="添加/编辑广告" :visible.sync="dialog" :close-on-click-modal="false">
      <el-form v-model="form" label-width="160px">

        <el-form-item label="广告简介">
          <el-input type="textarea" v-model="form.ad_desc"  placeholder="请输入公告内容,不超过200字"></el-input>
        </el-form-item>
        <!--<el-form-item label="广告内容">-->
          <!--<el-input type="textarea" v-model="form.content"  placeholder="请输入公告内容,不超过200字"></el-input>-->
        <!--</el-form-item>-->

        <el-form-item label="是否公布">
          <el-switch
                  v-model="form.is_publish"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="是否全店铺">
          <el-switch
                  v-model="form.all_type"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="显示范围">
          <el-radio-group v-model="form.show_type">
            <el-radio  label="0">全部</el-radio>
            <el-radio  label="1">仅app</el-radio>
            <el-radio  label="2">仅小程序</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input  v-model="form.sort"  placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="链接">
          <el-input  v-model="form.link"  placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="短链接">
          <el-input  v-model="form.short_link"  placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="小程序链接">
          <el-input  v-model="form.wx_app_link"  placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="优惠券">
          <el-select v-model="form.card_id" @change="changeCard(index)" placeholder="请选择优惠券" filterable >
            <el-option :label="v.title" :value="v.card_id" v-for="(v,i) in cardList" :key="v.card_id" ></el-option>
          </el-select>
        </el-form-item>
        <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
        <el-form-item label="图片">

          <div @click="handleImgPicker" class="upload-box">
            <img v-if="form.image" :src="form.image" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
          </div>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer content-center">
        <el-button type="primary" @click="handleSave" :disabled="clickable" >确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑店铺" :visible.sync="distributor_dialog" :close-on-click-modal="false">
      <el-form v-model="distributor_from" label-width="160px">
        <el-form-item label="广告描述">
          <el-input :disabled="true" v-model="distributor_from.ad_desc"  ></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <img  :src="wximageurl + distributor_from.image" style="width:300px;">
        </el-form-item>
        <el-form-item label="作用门店">
          <el-tag :key="item.distributor_id" class="new-tag" v-for="(item,index) in relDistributors" closable :disable-transitions="false" @close="handleClose(index)"> {{item.name}}
          </el-tag>
          <el-button size="medium" class="button-new-tag" @click="addDistributoreAction">+ 点击搜索店铺 </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer content-center">
        <el-button type="primary" @click="handleDistributionSave" :disabled="clickable" >确定</el-button>
      </div>
    </el-dialog>
    <DistributorSelect :store-visible="DistributorVisible" :is-valid="isValid" :rel-data-ids="relDistributors" :get-status="DistributorStatus" @chooseStore="DistributorChooseAction" @closeStoreDialog="closeDialogAction"></DistributorSelect>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { delDistributorAlterAd,addDistributorAlterAd,getDistributorAlterList,editDistributorAlterAdRelDis} from '../../../api/marketing'
    import DistributorSelect from '@/components/function/distributorSelect'
    import imgPicker from '@/components/imageselect'
    import { getCardList} from '@/api/cardticket'
    export default {
        
        components: {
            imgPicker,
            DistributorSelect,
        },
        data () {
            return {

                clickable:false,
                dialog: false,
                distributor_dialog:false,
                relDistributors:[],
                DistributorVisible: false,
                DistributorStatus: false,
                isValid: true,
                activeName: 'admin',
                list: [],
                total_count: 0,
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    ad_desc:'',
                },
                DistributorName:'',
                form: {
                    is_publish:false,
                    all_type: false,
                    link:'',
                    short_link:'',
                    wx_app_link:'',
                    ad_desc:'',
                    image:'',
                    sort:'',
                    card_id:'',
                    show_type:'',
                },
                distributor_from:{
                    id:'',
                    distributor_ids:[],
                    image:'',
                    ad_desc:'',
                    distributor_list:[],
                },
                picsDialog: false,
                imgDialog: false,
                isGetImage: false,
                imgIndex: 0,
                cardList: [],
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            handleClose(index) {
                this.relDistributors.splice(index, 1);
                this.distributor_from.distributor_ids.splice(index, 1);
            },
            DistributorChooseAction (data) {
                this.DistributorVisible = false
                this.DistributorStatus = false
                if (data === null || data.length <= 0) return
                this.relDistributors = data
                this.distributor_from.distributor_list = data
            },
            closeDialogAction () {
                this.DistributorStatus = false
                this.DistributorVisible = false
            },
            handleAdd(){
                this.dialog = true
                this.form.link = ''
                this.form.short_link = ''
                this.form.wx_app_link = ''
                this.form.ad_desc = ''
                this.form.image = ''
                this.form.is_publish = false
                this.form.all_type = false
                this.card_id = ''
                this.cardinfo = ''
                this.show_type = ''
            },
            addDistributoreAction() {
                this.DistributorVisible = true
                this.DistributorStatus = true
            },
            handleEditDistribution(row)
            {
                this.distributor_dialog = true
                this.distributor_from.ad_desc = row.ad_desc
                this.distributor_from.image = row.image
                this.distributor_from.id = row.id
                // row.distributorList.forEach(item => {
                //     alert(item.distributor_id);
                //     this.relDistributors.push(item.distributor_id)
                // })
                this.relDistributors = row.distributorList

            },
            handleDistributionSave(){
                editDistributorAlterAdRelDis(this.distributor_from).then(res => {
                    this.distributor_from = {
                        id:'',
                        distributor_ids:[],
                        image:'',
                        ad_desc:'',
                        distributor_list:[],
                    }
                    this.distributor_dialog = false
                    this.getList()
                    this.clickable = false
                    this.DistributorVisible = false
                    this.DistributorStatus = false
                    this.relDistributors = []

                    this.$message({ type: 'success', message: '操作成功' })
                })
            },
            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
                this.getParams()
                this.getList()
            },
            numberSearch () {
                this.params.page = 1
                this.getList()
            },
            handleUpdate(row) {
                this.dialog = true
                this.form.id = row.id
                this.form.is_publish = (row.is_publish == 1 ? true:false)
                this.form.all_type = (row.all_type == 1 ? true :false)
                this.form.content = row.content
                this.form.link = row.link
                this.form.short_link = row.short_link
                this.form.wx_app_link = row.wx_app_link
                this.form.ad_desc = row.ad_desc
                this.form.image = row.image
                this.form.sort = row.sort
                this.form.card_id = row.card_id
                this.form.show_type = row.show_type + ''
            },
            handleDelete(index, row) {
                this.$confirm('此操作将删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delDistributorAlterAd(row.id).then(response => {
                        this.list.splice(index, 1)
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            handleSave() {
                this.clickable = true
                if (this.form.id && this.form.id !==undefined) {
                    this.form.is_publish = (this.form.is_publish === true ? 1 : 0)
                    this.form.all_type = (this.form.all_type === true ? 1 : 0)
                }
                this.addAction()
            },

            addAction() {

                addDistributorAlterAd(this.form).then(res => {
                    this.form = {
                        is_publish:false,
                        all_type:false,
                        link  :'',
                        short_link : '',
                        wx_app_link : '',
                        ad_desc : '',
                        image : '',
                        sort:'',
                        show_type:'',
                        card_id:'',
                    }
                    this.dialog = false
                    this.getList()
                    this.clickable = false
                    this.$message({ type: 'success', message: '操作成功' })
                })

            },
            getList () {
                this.loading = true
                // alert(this.params.ad_desc);console.log(this.params);return false;
                getDistributorAlterList(this.params).then(response => {
                    if(response.data.data.list) {
                        // console.log(response.data.data.list)
                        this.list = response.data.data.list
                        this.total_count = Number(response.data.data.total_count)

                    }
                    this.loading = false
                })
            },
            handleImgPicker () {
                this.imgDialog = true
                this.isGetImage = true
            },
            pickImg (data) {
                this.form.image = data.url
                this.imgDialog = false
            },
            closeImgDialog () {
                this.imgDialog = false
                this.isGetImage = false
            },
            getCard(){
                getCardList({receive:false,page:1,page_size:10000}).then(res=>{
                    if(res.data){
                        this.cardList = res.data.data.list
                    }
                })
            },
            changeCard(index){

                var card = index
                var i = this.cardList.map((item) => item.card_id).indexOf(card);
            },
        },
        mounted () {
            this.getList()
            this.getCard()
        }
    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// alterAd.vue?7c811288